export const profile = {
  name: "Sahithi Rasakonda",
  firstName: "Sahithi",
  lastName: "Rasakonda",
  location: "Dortmund, Deutschland",
  email: "sahithiraj1206@gmail.com",
  phone: "+49 176 451 2277",
  linkedin: "https://www.linkedin.com/in/sahithi-rasakonda-4796a7217/",
  roles: [
    "Masterstudentin Psychologie & Management",
    "Angehende Arbeits- & Organisationspsychologin",
    "Forschungsbegeisterte",
    "Kreative Problemlöserin",
  ],
  statement:
    "Ich erforsche, was Menschen zum Aufblühen bringt — in Kliniken, in Hörsälen und in den Organisationen, die sie bauen. Mein Weg führt von kinderpsychologischen Stationen in Hyderabad zu Management-Hörsälen in Dortmund, geleitet von einer Überzeugung: Evidenz und Empathie gehören zusammen.",
  portrait: "/photos/hero-sunset.webp",
  cvUrl: "/Sahithi_Rasakonda_CV.pdf",
};

export const exploring = [
  {
    icon: "BookOpen",
    label: "Masterarbeit",
    title: "Mensch–KI-Interaktion in der Arbeitswelt",
    text: "Entwicklung einer Mixed-Methods-Studie über Vertrauen, Motivation und Sinn, wenn der Kollege ein Algorithmus ist.",
  },
  {
    icon: "Library",
    label: "Auf dem Nachttisch",
    title: "Lese ich gerade",
    text: "Thinking, Fast and Slow — Kahneman · Work Rules! — Bock · The Culture Code — Coyle.",
  },
  {
    icon: "GraduationCap",
    label: "Laufende Zertifizierungen",
    title: "Vertiefung des Werkzeugkastens",
    text: "Fortgeschrittene Statistik für Verhaltenswissenschaften und People-Analytics-Grundlagen.",
  },
  {
    icon: "FlaskConical",
    label: "Forschungsinteressen",
    title: "Wo meine Neugier lebt",
    text: "Wohlbefinden am Arbeitsplatz, Mensch–KI-Zusammenarbeit, Personalauswahl & Diagnostik, Organisationskultur.",
  },
  {
    icon: "Sparkles",
    label: "Fähigkeiten, die ich lerne",
    title: "Immer Studentin",
    text: "Deutsch, R für Datenanalyse und die stille Kunst besserer Interviews.",
  },
  {
    icon: "Compass",
    label: "Karriereziele",
    title: "Wohin der Weg führt",
    text: "Eine Rolle als A&O-Psychologin in der Organisationsentwicklung — Arbeitsplätze gestalten, an denen Menschen ihr Bestes geben.",
  },
];

export const about = {
  lead: "Die kürzeste Version: Ich bin eine Psychologin in Ausbildung, die sich in Organisationen verliebt hat.",
  paragraphs: [
    "Meine Geschichte beginnt in Hyderabad, Indien, wo ich Psychologie, Medienkommunikation und Literatur studiert habe — drei Blickwinkel auf dasselbe Thema: Menschen. Die Psychologie gab mir die Wissenschaft, die Kommunikation die Stimme und die Literatur die Geschichten. Seitdem webe ich sie zusammen.",
    "Das entscheidende Kapitel war ein einjähriges klinisches Praktikum am Rainbow Children's Hospital. Mit Familien zu sitzen, Diagnostik durchzuführen und Fallgeschichten zu schreiben, lehrte mich, dass Verhalten niemals zufällig ist — es ist Kommunikation, die auf jemanden wartet, der zuzuhören versteht. Es lehrte mich auch die Disziplin der Evidenz: Jede Erkenntnis musste Supervision, Diagnostik und Daten standhalten.",
    "Warum also Management? Weil dieselben Fragen, die eine Klinik erfüllen — Motivation, Vertrauen, Entwicklung, Wohlbefinden — jeden Arbeitsplatz erfüllen. Ich bin nach Deutschland gezogen, um Psychologie & Management an der International School of Management zu studieren, und habe ein Austauschsemester am St. Francis College in New York verbracht, wo ich lernte, wie Kultur alles verändert, was wir über Menschen annehmen.",
    "Was mich antreibt, ist einfach: Arbeit füllt den größten Teil unseres Wachseins, und sie sollte ein Ort sein, an dem Menschen wachsen statt nur durchzuhalten. Ich will diese Orte mitgestalten — mit Gründlichkeit, mit Wärme und mit dem Respekt einer Forscherin vor der Evidenz.",
  ],
  values: ["Neugier", "Empathie", "Evidenz", "Kreativität", "Ambition"],
};

export const education = [
  {
    period: "2024 — heute",
    degree: "M.Sc. Psychology and Management",
    institution: "International School of Management (ISM) — Deutschland",
    description:
      "Wo Psychologie auf den Sitzungssaal trifft. Meine Schwerpunkte reichen von Organisationsverhalten über Führung, kognitive Prozesse und statistische Analyse bis zur Mensch–KI-Interaktion — genau die Schnittstelle, an der meine Masterarbeit entsteht.",
    tags: ["Organisationsverhalten", "Führung", "Forschungsmethodik", "Projektmanagement", "Statistik"],
  },
  {
    period: "Herbst 2025",
    degree: "Austauschsemester — Psychologie & Wirtschaft",
    institution: "St. Francis College — New York, USA",
    description:
      "Ein Semester in Brooklyn, das interkulturelle Kommunikation vom Kursthema zur täglichen Praxis machte. New York lehrte mich, im Stehen zu denken — und alles zu hinterfragen, was ich für universell über Menschen hielt.",
    tags: ["Interkulturelle Kommunikation", "Internationale Perspektive"],
  },
  {
    period: "2023",
    degree: "Diplom in Organisationspsychologie",
    institution: "Cognizavest",
    description:
      "Mein erster formeller Schritt in die Arbeitspsychologie — die Brücke zwischen meinen klinischen Grundlagen und meiner Zukunft in Organisationen.",
    tags: ["Organisationspsychologie"],
  },
  {
    period: "2019 — 2022",
    degree: "B.A. Psychologie, Medienkommunikation & Literatur",
    institution: "Villa Marie Degree College — Hyderabad, Indien",
    description:
      "Drei Disziplinen, ein Thema: Menschen. Hier haben sich die Wissenschaftlerin, die Kommunikatorin und die Geschichtenerzählerin in mir zum ersten Mal getroffen.",
    tags: ["Psychologie", "Medienkommunikation", "Literatur"],
  },
];

export const experience = [
  {
    role: "Praktikantin Klinische Psychologie",
    org: "Rainbow Children's Hospital — Hyderabad, Indien",
    period: "Juli 2023 — Juni 2024",
    summary: "Ein einjähriges intensives pädiatrisches Praktikum in einem multidisziplinären Klinikteam.",
    learned:
      "Ich habe gelernt, dass die Diagnostik lange vor dem Test beginnt. IQ- und Entwicklungsdiagnostik, ADHD-Screenings, CARS-Evaluationen und Lernstörungsprofile lehrten mich psychometrische Gründlichkeit — doch die Zeit mit Familien lehrte mich Zuhören. Ich ging mit der Fähigkeit, Beobachtungen in individuelle Interventionspläne und Daten in Entscheidungen zu verwandeln, denen Familien vertrauen können.",
    impact:
      "Mitwirkung an diagnostischen Fallkonferenzen, Erstellung klinischer Berichte und ehrenamtliche Mitarbeit auf der Nationalen Konferenz zu Autismus-Spektrum-Störungen — in Abstimmung mit Psychologen, Psychiatern und Therapeuten.",
    skills: ["Psychometrische Diagnostik", "Klinische Berichte", "Fallmanagement", "Familienberatung"],
  },
  {
    role: "Praktikantin Social Media Marketing & Community Engagement",
    org: "Digitale Öffentlichkeitsarbeit — Hyderabad, Indien",
    period: "2023",
    summary: "Digitale Kampagnen gestalten, die Psychologie in Kommunikation übersetzen.",
    learned:
      "Ich habe gelernt, dass Engagement angewandte Psychologie ist. Jede Kampagne war ein kleines Experiment in Aufmerksamkeit, Motivation und Botschaftsgestaltung — und die funktionsübergreifende Zusammenarbeit zeigte mir, dass Kommunikationsstrategie in Wahrheit Menschenstrategie ist.",
    impact: "Verbessertes Community-Engagement und höhere Markensichtbarkeit durch evidenzinformierte Kampagnen.",
    skills: ["Kommunikationsstrategie", "Community Engagement", "Funktionsübergreifende Zusammenarbeit"],
  },
  {
    role: "Praktikantin Kognitive Rehabilitation",
    org: "ARDSI — Hyderabad Deccan Chapter",
    period: "2022",
    summary: "Unterstützung von Demenzbetreuungsprogrammen durch strukturierte kognitive Rehabilitation.",
    learned:
      "Die Arbeit mit Demenzpatienten hat Fortschritt für mich neu definiert: kleine, würdevolle Siege, die Geduld und Präzision gleichermaßen verlangen. Therapieaktivitäten gemeinsam mit erfahrenen Psychologinnen zu gestalten zeigte mir, wie Empathie aussieht, wenn sie Methode wird.",
    impact: "Note A für herausragende Leistung und empathiebasierte Betreuung.",
    skills: ["Kognitive Rehabilitation", "Therapiegestaltung", "Verlaufsevaluation"],
  },
  {
    role: "Praktikantin Beratungspsychologie",
    org: "Psychoflakes",
    period: "2020",
    summary: "Erste angeleitete Schritte in Beratungspraxis und Fallanalyse.",
    learned:
      "Meine ersten supervisierten Beratungssitzungen lehrten mich die Disziplin der Präsenz — und dass die richtige Frage eine Fähigkeit ist, die man wie jede andere trainiert. Gruppeninterventionen schärften mein angewandtes Problemlösen und meine zwischenmenschliche Bandbreite.",
    impact: "Durchführung supervisierter Sitzungen, Fallanalysen und Präsentationen zu Gruppeninterventionen.",
    skills: ["Beratung", "Fallanalyse", "Gruppenintervention"],
  },
];

export const projects = [
  {
    num: "01",
    title: "Mensch–KI-Interaktion in der modernen Arbeitswelt",
    kind: "Masterarbeit — in Arbeit",
    overview:
      "Eine Untersuchung des psychologischen Vertrags zwischen Menschen und intelligenten Systemen bei der Arbeit: Was passiert mit Vertrauen, Motivation und Sinn, wenn der Kollege ein Algorithmus ist?",
    objective:
      "Zu verstehen, wie KI-Einführung das Erleben von Arbeit prägt — jenseits von Produktivitätsmetriken, hinein in Autonomie, Vertrauen und Sinn.",
    methodology: "Mixed-Methods-Design: quantitative Befragung in der Breite, gefolgt von halbstrukturierten Interviews für die Tiefe.",
    tools: ["SPSS", "Survey Design", "Interview Protocols", "Literature Synthesis"],
    outcome: "Expose erstellt; Forschungsdesign und Literaturrahmen in Arbeit an der ISM.",
    lesson: "Die besten Forschungsfragen entstehen, wenn man zuhört, was Praktiker wirklich beschäftigt.",
  },
  {
    num: "02",
    title: "Früherkennung von Entwicklungsbedarf bei Kindern",
    kind: "Klinische Fallserie — Rainbow Children's Hospital",
    overview:
      "Eine einjährige angewandte Studie in pädiatrischer psychologischer Diagnostik — von IQ- und Entwicklungstests über ADHD-Screening und Autismus-Diagnostik (CARS) bis zu Profilen spezifischer Lernstörungen.",
    objective: "Psychometrische Evidenz in Interventionspläne zu übersetzen, mit denen Familien und Kliniker gemeinsam arbeiten können.",
    methodology: "Standardisierte psychometrische Testbatterien, strukturierte Fallgeschichten, diagnostische Fallkonferenzen unter Supervision.",
    tools: ["IQ-/DQ-Diagnostik", "CARS", "ADHD-Screening", "Klinische Berichte"],
    outcome: "Dutzende Diagnostikverfahren und klinische Berichte als Grundlage individueller Interventionspläne.",
    lesson: "Daten gewinnen Vertrauen nur, wenn sie mit Empathie vermittelt werden.",
  },
  {
    num: "03",
    title: "Nationale Konferenz zu Autismus-Spektrum-Störungen",
    kind: "Forschung & Ehrenamt",
    overview:
      "Zwei Tage mitten in Indiens Debatte über Autismus — Sessions koordinieren und direkt mit den Psychologen, Psychiatern und Therapeuten sprechen, die das Feld prägen.",
    objective: "Mein Verständnis von Spektrumsforschung und Intervention über den Hörsaal hinaus zu vertiefen.",
    methodology: "Veranstaltungskoordination, fachlicher Austausch und strukturierte Beobachtung von Forschungsvorträgen.",
    tools: ["Veranstaltungskoordination", "Fachliches Networking", "Forschungssynthese"],
    outcome: "Unmittelbarer Einblick in aktuelle ASS-Forschung und Interventionspraxis auf nationaler Ebene.",
    lesson: "Ein Feld bewegt sich in Gesprächen voran, nicht nur in Publikationen.",
  },
  {
    num: "04",
    title: "Digitale Öffentlichkeitsarbeit & Community Engagement",
    kind: "Angewandtes Kommunikationsprojekt",
    overview:
      "Eine Kampagnenpraxis, die Community Engagement als angewandte Psychologie behandelt — Öffentlichkeitsarbeit gestaltet entlang dessen, wie Menschen wirklich aufmerken, entscheiden und sich verbinden.",
    objective: "Markensichtbarkeit und Community Engagement durch evidenzinformierte Kommunikation stärken.",
    methodology: "Kampagnendesign, Content-Experimente, funktionsübergreifende Zusammenarbeit, Reichweitenanalyse.",
    tools: ["Content Strategy", "Analytics", "Google Workspace"],
    outcome: "Messbar verbessertes Engagement und Online-Reichweite für die unterstützten Community-Programme.",
    lesson: "Kommunikationsstrategie ist Menschenstrategie.",
  },
];

export const skillGroups = [
  {
    title: "Psychologie & klinische Praxis",
    span: "wide",
    items: [
      "Psychometrische Diagnostik",
      "IQ- & Entwicklungsdiagnostik",
      "Evidenzbasierte Intervention",
      "Fallgeschichte & Berichte",
      "Kognitive Rehabilitation",
      "Beratung",
    ],
  },
  {
    title: "Forschung & Statistik",
    span: "tall",
    items: ["Forschungsmethodik", "Statistische Analyse", "SPSS", "Datenanalyse", "Wissenschaftliches Schreiben"],
  },
  {
    title: "Organisation & Management",
    span: "square",
    items: ["Organisationsverhalten", "Führung", "Projektplanung", "Verhandlung & Konfliktlösung"],
  },
  {
    title: "Kommunikation & Führung",
    span: "square",
    items: ["Präsentation & Reden", "Aktives Zuhören", "Interkulturelle Kommunikation", "Teamkoordination"],
  },
  {
    title: "Sprachen",
    span: "square",
    items: ["Englisch — fließend", "Telugu — Muttersprache", "Hindi — zweisprachig", "Deutsch — Anfängerin", "Französisch — Grundkenntnisse"],
  },
  {
    title: "Digitale Werkzeuge",
    span: "wide",
    items: ["MS Office", "Google Workspace", "KI-Produktivitätstools", "SPSS"],
  },
];

export const certificates = [
  { title: "Lösungsorientierte Kurzzeittherapie (SFBT)", issuer: "Zertifizierung", year: "Klinische Weiterbildung" },
  { title: "Statistik & Datenanalyse", issuer: "Zertifizierung", year: "Forschungsmethodik" },
  { title: "Rorschach-Test-Training", issuer: "Workshop", year: "Diagnostik" },
  { title: "AMI-Workshop: Einführung Adoleszenz", issuer: "Workshop", year: "Entwicklung" },
  { title: "SuJok-Therapie — Level 1", issuer: "Zertifizierung", year: "Komplementäre Praxis" },
  { title: "BSS-Diplom in Akupunktur & Naturheilkunde", issuer: "Diplom", year: "Komplementäre Praxis" },
];

export const achievements = [
  {
    title: "Note A — Herausragende Leistung",
    detail: "Ausgezeichnet für empathiebasierte Betreuung in der kognitiven Rehabilitation bei ARDSI.",
  },
  {
    title: "1. Preis Fotografie",
    detail: "Jupiter Academy of Audio Visual Communications, während eines Filmemacher-Kurses.",
  },
  {
    title: "Ehrenamt Community Wellness",
    detail: "Mehrere Programme zu Gemeindewohlbefinden und Mental-Health-Aufklärung.",
  },
];

export const interests = [
  {
    title: "Lesen",
    slug: "reading",
    text: "Verhaltenswissenschaft, Romane und alles, was Menschen erklärt.",
    image: "https://images.unsplash.com/photo-1512820790803-83ca734da794?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Fotografie",
    slug: "photography",
    text: "Eine preisgekrönte Gewohnheit des Beobachtens — Licht, Gesichter, stille Momente.",
    image: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Reisen",
    slug: "traveling",
    text: "Von Hyderabad nach Dortmund und New York — Kulturen sind meine Feldstudien.",
    image: "/photos/brooklyn-bridge.webp",
  },
  {
    title: "Journaling",
    slug: "journaling",
    text: "Wo aus Gedanken Forschungsfragen werden.",
    image: "https://images.unsplash.com/photo-1586380951230-e6703d9f6833?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Kaffeekultur",
    slug: "coffee-culture",
    text: "Jede Stadt, in der ich lebte, erinnert in Cafés.",
    image: "/photos/coffee-gimbal.webp",
  },
  { title: "Persönliches Wachstum", slug: "growth", text: "Mich selbst als lebenslange Pilotstudie behandeln.", icon: "Sprout" },
];

export const gallery = [
  {
    src: "/photos/train-journey.webp",
    caption: "Fensterplätze und wandernde Gedanken",
    tag: "Reisen",
    ratio: "aspect-[3/4]",
  },
  {
    src: "/photos/cafe-evening.jpeg",
    caption: "Ein gut verbrachter Abend",
    tag: "Alltag",
    ratio: "aspect-[3/4]",
  },
  {
    src: "/photos/snow-day.webp",
    caption: "Schneetag in New York",
    tag: "Reisen",
    ratio: "aspect-[3/4]",
  },
  {
    src: "/photos/nyc-nights.webp",
    caption: "Manhattan nach Einbruch der Dunkelheit",
    tag: "Reisen",
    ratio: "aspect-[4/3]",
  },
  {
    src: "/photos/autumn-walk.webp",
    caption: "Herbst unter den Füßen",
    tag: "Alltag",
    ratio: "aspect-[3/4]",
  },
  {
    src: "/photos/budapest-parliament.webp",
    caption: "Budapest, in Gold gekleidet",
    tag: "Reisen",
    ratio: "aspect-[3/4]",
  },
  {
    src: "/photos/grand-central.webp",
    caption: "Ein Bahnhof wie eine Kathedrale",
    tag: "Reisen",
    ratio: "aspect-[3/4]",
  },
  {
    src: "/photos/bookshop-nyc.webp",
    caption: "Bücher, schwebend",
    tag: "Kreativ",
    ratio: "aspect-[3/4]",
  },
  {
    src: "/photos/nordic-road.webp",
    caption: "Sonnenuntergang am Ende der Landkarte",
    tag: "Reisen",
    ratio: "aspect-[4/3]",
  },
  {
    src: "/photos/lighthouse-sea.webp",
    caption: "Der Leuchtturm am Rand",
    tag: "Reisen",
    ratio: "aspect-[4/3]",
  },
  {
    src: "/photos/museum-day.webp",
    caption: "Museumstunden",
    tag: "Kreativ",
    ratio: "aspect-[3/4]",
  },
  {
    src: "/photos/bookshop-curiosities.webp",
    caption: "Halb Buchladen, halb Universum",
    tag: "Kreativ",
    ratio: "aspect-[3/4]",
  },
  {
    src: "/photos/library-steps.webp",
    caption: "Bibliothekstreppen",
    tag: "Alltag",
    ratio: "aspect-[3/4]",
  },
];

export const marqueeItems = [
  "Psychologie & Management",
  "Forschung mit Menschlichkeit",
  "Organisationsverhalten",
  "Evidenz & Empathie",
  "Neugier, immer",
];

export const marqueeDark = [
  "Forschung in Arbeit",
  "Mensch–KI-Interaktion",
  "Wohlbefinden am Arbeitsplatz",
  "Evidenz & Empathie",
];
